// saarthi-landing/src/components/public/verifyEmail/EmailVerified.js

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';


const EmailVerified = () => {
    return (
        <Container fluid className="email-verified-container text-center mt-5">
            <Row className="justify-content-center">
                <Col md={8} className="content-style">
                    <h1 className="mb-4" style={{ color: '#28a745' }}>Your email has been verified!</h1>
                    <p className="sub-text" style={{ fontSize: '18px' }}>
                        Thank you for verifying your email address. You can now enjoy all the features of Saarthi.
                    </p>
                </Col>
            </Row>
        </Container>
    );
};

export default EmailVerified;
